import SchoolIcon from "@mui/icons-material/School";
import {
    Box,
    Button,
    Card,
    CardHeader,
    Stack,
    Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

// import { MdScience } from "react-icons/md";
// import { PiMathOperationsFill } from "react-icons/pi";
// import { FaGear } from "react-icons/fa6";
// import { FaComputer } from "react-icons/fa6";
// import { FaRobot } from "react-icons/fa6";

const SubjectCard = ({ title, subjectId, masterId, disabled }) => {

    const navigate = useNavigate();

    const handleTakeAssessment = () => {
        console.log("Take assessment -- ", subjectId)

        /**
         * setting cookie for quizId
         */
        sessionStorage.setItem("subjectId", subjectId);
        sessionStorage.setItem("masterId", masterId);
        navigate("/StudentDashboard/Assessment/AssessmentContent");
    };

    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            gap="20px"
            border="1px solid #F3F0EC"
            padding="10px"
            borderRadius="6px"
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                <SchoolIcon color="secondary" />
                <Typography variant="h5">{title} Assessment</Typography>
            </Box>
            <Box>
                <Button
                    variant="contained"
                    color="secondary"
                    disabled={disabled}
                    onClick={handleTakeAssessment}
                >
                    Take Assessment
                </Button>
            </Box>
        </Stack>
    );
};

export default SubjectCard;
